import classNames from 'classnames';
import styles from './FoldButton.module.scss';
import { FoldButtonProps } from './FoldButton.type';

const FoldButton = ({ open, onClick }: FoldButtonProps) => {
    return <span className={classNames(styles['fold-btn'], { [styles['open']]: open })} onClick={onClick}></span>;
};

export default FoldButton;
